import { Generator, Login, NotFound, Progress } from "pages";
import { Route, Routes } from "react-router-dom";
import AppLayout from "ui/templates/AppLayout";

function App() {
  return (
    <Routes>
      <Route index element={<Login />} />
      <Route
        path="/generator"
        element={
          <AppLayout>
            <Generator />
          </AppLayout>
        }
      />
      <Route path="*" element={<NotFound />} />
      <Route
        path="/progress"
        element={
          <AppLayout>
            <Progress />
          </AppLayout>
        }
      />

    </Routes>
  );
}

export default App;
